import React from 'react';

export interface ImageProps {
  /**
   * Image source URL
   */
  src: string;
  /**
   * Alternative text for accessibility
   */
  alt: string;
  /**
   * Image width
   */
  width?: number | string;
  /**
   * Image height
   */
  height?: number | string;
  /**
   * Loading strategy
   */
  loading?: 'lazy' | 'eager';
  /**
   * Image variant for specific use cases
   */
  variant?: 'default' | 'icon';
  /**
   * Custom CSS classes
   */
  className?: string;
  /**
   * Inline styles
   */
  style?: React.CSSProperties;
  /**
   * Click handler
   */
  onClick?: (event: React.MouseEvent<HTMLImageElement>) => void;
  /**
   * HTML id attribute
   */
  id?: string;
  /**
   * HTML title attribute
   */
  title?: string;
}

export const Image: React.FC<ImageProps> = ({
  src,
  alt,
  width,
  height,
  loading = 'lazy',
  variant = 'default',
  className = '',
  style,
  onClick,
  id,
  title,
}) => {
  const baseClass = 'hi-ui-image';
  const variantClass = variant !== 'default' ? `hi-ui-image-${variant}` : '';
  const allClasses = `${baseClass} ${variantClass} ${className}`.trim();

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      className={allClasses}
      style={style}
      onClick={onClick}
      id={id}
      title={title}
    />
  );
};
